import { memo, useEffect, useState } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

import './LoadingSpinner.css';

type LoadingSpinnerProps = {
  color?: string;
  size?: number;
  loading: boolean;
};

export const LoadingSpinner = memo(
  ({ color = '#fff', size = 100, loading }: LoadingSpinnerProps) => {
    const [showSpinner, setShowSpinner] = useState(false);

    useEffect(() => {
      if (loading) {
        const timeout = setTimeout(() => {
          setShowSpinner(true);
        }, 1000);
        return () => clearTimeout(timeout);
      }

      setShowSpinner(false);
      return undefined;
    }, [loading]);

    return (
      <div
        className="overlay"
        style={{ backgroundColor: showSpinner ? '#000000B3' : 'transparent' }}
      >
        <ClipLoader loading={showSpinner} size={size} color={color} />
      </div>
    );
  },
);
